// Added by Sejune Oh on 2020-02-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Component, createRef } from 'react'
import { observer } from 'mobx-react'
import { action, makeObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { ReactFormEvent } from '@/helper/define'
import Intl from '@/helper/Intl'
import { getFormData } from '@/helper/util'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { UserCustomInfoProp } from '@/stores/mgmt/user/UserStore'
import CustomInfoDialog from './CustomInfoDialog'
import Dialog from '@/components/common/Dialog'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface

interface StudyTagDialogCProps {
  onDialogConfirm: (arg: { customInfoElement: UserCustomInfoProp | null; err: Error | null }) => Promise<{}>
  customInfoElement?: UserCustomInfoProp
  menuItems: string[]
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
@observer
class StudyTagDialogContainer extends Component<StudyTagDialogCProps> {
  _formId = 'c-i-d'
  _dialogRef = createRef<Dialog>()

  constructor(props: StudyTagDialogCProps) {
    super(props)
    makeObservable(this, {
      openDialog: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  render() {
    return (
      <CustomInfoDialog
        formId={this._formId}
        dialogRef={this._dialogRef}
        onDialogConfirm={this._handleDialogConfirm}
        customInfoElement={this.props.customInfoElement}
        onFormSubmit={this._handleFormSubmit}
        menuItems={this.props.menuItems}
      />
    )
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  openDialog = async () => {
    let title: string = ''
    let confirmBtn: string = ''

    if (this.props.customInfoElement) {
      title = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfodialogcontainer.dialog_title_edit' })
      confirmBtn = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfodialogcontainer.dialog_btn_update' })
    } else {
      title = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfodialogcontainer.dialog_title_add' })
      confirmBtn = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfodialogcontainer.dialog_btn_add' })
    }

    this._dialogRef
      .current!.setDialogInfo({
        title,
        confirmBtn,
      })
      .handleOpen()
  }

  _handleDialogConfirm = () => {
    let customInfoElement: UserCustomInfoProp | null = null
    let e: Error | null = null

    try {
      customInfoElement = getFormData<UserCustomInfoProp>(
        document.getElementById(this._formId) as HTMLFormElement
      ) as UserCustomInfoProp
    } catch (err) {
      e = err
    } finally {
      const { key, value } = customInfoElement || { key: '', value: '' }
      return this.props.onDialogConfirm({
        customInfoElement: { key, value },
        err: e,
      })
    }
  }

  _handleFormSubmit: ReactFormEvent = (e) => {
    e.preventDefault()
  }
}

export default StudyTagDialogContainer
